import React from 'react';
import { useLocation } from 'react-router-dom';
import { PageLayout } from './PageLayout';
import { Header, HeaderSpacer } from './Header';

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  const path = location.pathname;

  // Liste des routes qui ne doivent pas utiliser le PageLayout
  const excludedRoutes = [
    '/',              // Landing page
    '/login',         // Page de connexion
    '/register',      // Page d'inscription
    '/pvp/match',     // Page de jeu PvP
  ];

  // Vérifie si la route actuelle est exclue
  const shouldExcludeLayout = excludedRoutes.some(route => path === route || path.startsWith(route + '/'));

  return (
    <>
      <Header />
      <HeaderSpacer />
      {shouldExcludeLayout ? children : <PageLayout>{children}</PageLayout>}
    </>
  );
} 